
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ThemeService } from '../services/theme.service';
import { DomHelperService } from '../services/dom-helper.service';
import { AppDataService } from '../services/app-data.service';
import { Observable, share, mergeMap, map } from 'rxjs';
import { TranslationService } from '../services/translate.service';
import { LocalStorage } from '../helpers/localstorage.helper';
import { SettingsService } from '../services/settings.service';
let shared: Observable<any>;


export const providers = [
  // Use the “multi: true” option for multiple injection tokens, to restrict to one, use “multi: false”
  // We use "true", since we have multiple providers using the APP_INITIALIZER token, hence multiple tokens.
  {
    provide: APP_INITIALIZER,
    useFactory: (a: AppDataService) => init_app.bind(this, a,),
    deps: [AppDataService],
    multi: true,
  },
  {
    provide: APP_INITIALIZER,
    useFactory: (t: TranslationService,s:SettingsService) => get_localizations.bind(this, t,s),
    deps: [TranslationService,SettingsService],
    multi: true,
  },

  // ThemeService,
  // {
  //   provide: APP_INITIALIZER,
  //   useFactory: get_theme,
  //   multi: true,
  //   deps: [ThemeService]
  // },
  // DomHelperService,
  // {
  //   provide: APP_INITIALIZER,
  //   useFactory: init_domHelper,
  //   deps: [DomHelperService],
  //   multi: true
  // }
];


// functions should always return a function. The initialization process will wait for this to finish before
// it continues.

export function init_app(appDataService: AppDataService): Observable<any> {
  shared = appDataService.LoadConfigurations().pipe(share())
  return shared;
}

export function get_localizations(
    TranslationService: TranslationService,
    settingsService: SettingsService): Observable<any> {
    return shared.pipe(
        mergeMap(() =>
            TranslationService.loadLocalization().pipe(
                mergeMap((translations) =>
                    settingsService.loadSettings().pipe(
                        mergeMap((settings) =>
                            settingsService.loadLookups().pipe(
                                map((lookups) => [translations, settings, lookups])
                            )
                        )
                    )
                )
            )
        )
    );
}

export function get_theme(themeService: ThemeService) {
  return () => {
    return new Promise<void>((resolve, reject) => {
      const storedTheme = LocalStorage.get('isDarkMode');
      const isDarkMode = storedTheme ? JSON.parse(storedTheme) : false;
      themeService.toggleDarkMode(isDarkMode);
      resolve();
    });
  };
}

export function init_domHelper(domService: DomHelperService) {
  return () => {
    return new Promise<void>((resolve, reject) => {
      const storedTheme = LocalStorage.get('isDarkMode');
      const isDarkMode = storedTheme ? JSON.parse(storedTheme) : false;

      if (isDarkMode) {
        domService.addThemeClass('dark-theme');
      }

      resolve();
    });
  };
}

@NgModule({
  providers: providers
})

// we can use this module to get information from a server, before loading up the app, like the environment etc.
export class AppInitializationModule { }
